import { useState, useEffect } from "react";
import { tiposAreaVerde, statusArea, categoriasUC, gruposUC, statusGestaoUC } from "@/mocks/ambiental";

interface NewEnvironmentalAreaModalProps {
  open: boolean;
  isUC: boolean;
  onClose: () => void;
}

export default function NewEnvironmentalAreaModal({ open, isUC, onClose }: NewEnvironmentalAreaModalProps) {
  const [step, setStep] = useState(1);
  const [nome, setNome] = useState("");
  const [tipo, setTipo] = useState("");
  const [categoria, setCategoria] = useState("");
  const [grupo, setGrupo] = useState("");
  const [municipio, setMunicipio] = useState("Goiânia");
  const [uf, setUf] = useState("GO");
  const [bairro, setBairro] = useState("");
  const [areaHa, setAreaHa] = useState("");
  const [responsavel, setResponsavel] = useState("");
  const [orgaoGestor, setOrgaoGestor] = useState("");
  const [instrumentoLegal, setInstrumentoLegal] = useState("");
  const [numeroLei, setNumeroLei] = useState("");
  const [temPlanoManejo, setTemPlanoManejo] = useState(false);
  const [status, setStatus] = useState("");
  const [observacoes, setObservacoes] = useState("");

  useEffect(() => {
    if (open) {
      setStep(1);
      setNome(""); setTipo(""); setCategoria(""); setGrupo(""); setBairro("");
      setAreaHa(""); setResponsavel(""); setOrgaoGestor(""); setInstrumentoLegal("");
      setNumeroLei(""); setTemPlanoManejo(false); setStatus(""); setObservacoes("");
    }
  }, [open]);

  if (!open) return null;

  const handleSubmit = () => {
    onClose();
  };

  return (
    <>
      <div className="fixed inset-0 bg-black/30 z-50" onClick={onClose}></div>
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-xl shadow-xl w-full max-w-lg max-h-[90vh] overflow-y-auto">
          {/* Header */}
          <div className="flex items-center justify-between px-6 py-4 border-b border-background-200 sticky top-0 bg-white rounded-t-xl">
            <div>
              <h3 className="text-lg font-semibold text-foreground-900 font-heading">
                {isUC ? "Nova Unidade de Conservação" : "Nova Área Verde"}
              </h3>
              <p className="text-xs text-foreground-500">Etapa {step} de 3</p>
            </div>
            <button onClick={onClose} className="w-8 h-8 rounded-btn flex items-center justify-center text-foreground-400 hover:bg-background-100 transition-colors cursor-pointer">
              <i className="ri-close-line text-lg"></i>
            </button>
          </div>

          {/* Content */}
          <div className="px-6 py-4 space-y-4">
            {/* Step 1: Basic Info */}
            {step === 1 && (
              <>
                <div>
                  <label className="text-xs text-foreground-500 mb-1 block">Nome *</label>
                  <input type="text" value={nome} onChange={(e) => setNome(e.target.value)} placeholder={isUC ? "Ex: Parque Natural Municipal do Cerrado" : "Ex: Praça Universitária"} className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn focus:outline-none focus:border-primary-400 bg-background-50" />
                </div>
                <div className="grid grid-cols-2 gap-3">
                  {isUC ? (
                    <>
                      <div>
                        <label className="text-xs text-foreground-500 mb-1 block">Categoria *</label>
                        <select value={categoria} onChange={(e) => setCategoria(e.target.value)} className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn focus:outline-none focus:border-primary-400 bg-background-50">
                          <option value="">Selecione</option>
                          {categoriasUC.map((c) => (<option key={c} value={c}>{c}</option>))}
                        </select>
                      </div>
                      <div>
                        <label className="text-xs text-foreground-500 mb-1 block">Grupo *</label>
                        <select value={grupo} onChange={(e) => setGrupo(e.target.value)} className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn focus:outline-none focus:border-primary-400 bg-background-50">
                          <option value="">Selecione</option>
                          {gruposUC.map((g) => (<option key={g} value={g}>{g}</option>))}
                        </select>
                      </div>
                    </>
                  ) : (
                    <>
                      <div>
                        <label className="text-xs text-foreground-500 mb-1 block">Tipo de Área *</label>
                        <select value={tipo} onChange={(e) => setTipo(e.target.value)} className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn focus:outline-none focus:border-primary-400 bg-background-50">
                          <option value="">Selecione</option>
                          {tiposAreaVerde.map((t) => (<option key={t} value={t}>{t}</option>))}
                        </select>
                      </div>
                      <div>
                        <label className="text-xs text-foreground-500 mb-1 block">Status</label>
                        <select value={status} onChange={(e) => setStatus(e.target.value)} className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn focus:outline-none focus:border-primary-400 bg-background-50">
                          <option value="">Selecione</option>
                          {statusArea.map((s) => (<option key={s} value={s}>{s}</option>))}
                        </select>
                      </div>
                    </>
                  )}
                </div>
                <div className="grid grid-cols-3 gap-3">
                  <div className="col-span-2">
                    <label className="text-xs text-foreground-500 mb-1 block">Município *</label>
                    <input type="text" value={municipio} onChange={(e) => setMunicipio(e.target.value)} className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn focus:outline-none focus:border-primary-400 bg-background-50" />
                  </div>
                  <div>
                    <label className="text-xs text-foreground-500 mb-1 block">UF *</label>
                    <input type="text" value={uf} onChange={(e) => setUf(e.target.value)} className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn focus:outline-none focus:border-primary-400 bg-background-50" maxLength={2} />
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className="text-xs text-foreground-500 mb-1 block">Bairro</label>
                    <input type="text" value={bairro} onChange={(e) => setBairro(e.target.value)} placeholder="Ex: Setor Central" className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn focus:outline-none focus:border-primary-400 bg-background-50" />
                  </div>
                  <div>
                    <label className="text-xs text-foreground-500 mb-1 block">Área (ha) *</label>
                    <input type="number" value={areaHa} onChange={(e) => setAreaHa(e.target.value)} placeholder="Ex: 12.5" className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn focus:outline-none focus:border-primary-400 bg-background-50" min={0} step={0.1} />
                  </div>
                </div>
              </>
            )}

            {/* Step 2: Legal/Administrative */}
            {step === 2 && (
              <>
                <div>
                  <label className="text-xs text-foreground-500 mb-1 block">{isUC ? "Órgão Gestor *" : "Responsável *"}</label>
                  <input type="text" value={isUC ? orgaoGestor : responsavel} onChange={(e) => isUC ? setOrgaoGestor(e.target.value) : setResponsavel(e.target.value)} placeholder={isUC ? "Ex: Secretaria Municipal de Meio Ambiente" : "Ex: AMMA"} className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn focus:outline-none focus:border-primary-400 bg-background-50" />
                </div>
                {isUC && (
                  <>
                    <div>
                      <label className="text-xs text-foreground-500 mb-1 block">Instrumento Legal</label>
                      <input type="text" value={instrumentoLegal} onChange={(e) => setInstrumentoLegal(e.target.value)} placeholder="Ex: Decreto Municipal nº 8.742/2012" className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn focus:outline-none focus:border-primary-400 bg-background-50" />
                    </div>
                    <div>
                      <label className="text-xs text-foreground-500 mb-1 block">Número da Lei/Decreto</label>
                      <input type="text" value={numeroLei} onChange={(e) => setNumeroLei(e.target.value)} placeholder="Ex: 8.742/2012" className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn focus:outline-none focus:border-primary-400 bg-background-50" />
                    </div>
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input type="checkbox" checked={temPlanoManejo} onChange={(e) => setTemPlanoManejo(e.target.checked)} className="rounded border-background-300 text-primary-500 focus:ring-primary-400" />
                      <span className="text-sm text-foreground-700">Possui Plano de Manejo</span>
                    </label>
                    <div>
                      <label className="text-xs text-foreground-500 mb-1 block">Status de Gestão</label>
                      <select value={status} onChange={(e) => setStatus(e.target.value)} className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn focus:outline-none focus:border-primary-400 bg-background-50">
                        <option value="">Selecione</option>
                        {statusGestaoUC.map((s) => (<option key={s} value={s}>{s}</option>))}
                      </select>
                    </div>
                  </>
                )}
                <div>
                  <label className="text-xs text-foreground-500 mb-1 block">Polígono/Geometria</label>
                  <div className="border-2 border-dashed border-background-300 rounded-xl p-8 text-center cursor-pointer hover:border-primary-400 transition-colors bg-background-50">
                    <div className="w-10 h-10 rounded-lg bg-background-200 flex items-center justify-center mx-auto mb-2">
                      <i className="ri-upload-cloud-line text-foreground-500 text-lg"></i>
                    </div>
                    <p className="text-xs text-foreground-500">Importar arquivo GeoJSON, Shapefile ou KML</p>
                    <p className="text-[10px] text-foreground-400 mt-1">Ou desenhar polígono no mapa</p>
                  </div>
                </div>
              </>
            )}

            {/* Step 3: Review */}
            {step === 3 && (
              <div className="space-y-3">
                <div className="bg-background-50 rounded-xl p-4">
                  <h4 className="text-sm font-semibold text-foreground-900 font-heading mb-3">Resumo do Cadastro</h4>
                  <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-sm">
                    <div><span className="text-xs text-foreground-500">Nome</span><p className="text-foreground-900">{nome || "—"}</p></div>
                    <div><span className="text-xs text-foreground-500">{isUC ? "Categoria" : "Tipo"}</span><p className="text-foreground-900">{isUC ? categoria : tipo || "—"}</p></div>
                    {isUC && <div><span className="text-xs text-foreground-500">Grupo</span><p className="text-foreground-900">{grupo || "—"}</p></div>}
                    <div><span className="text-xs text-foreground-500">Município/UF</span><p className="text-foreground-900">{municipio}/{uf}</p></div>
                    <div><span className="text-xs text-foreground-500">Área</span><p className="text-foreground-900">{areaHa || "—"} ha</p></div>
                    <div><span className="text-xs text-foreground-500">{isUC ? "Órgão Gestor" : "Responsável"}</span><p className="text-foreground-900">{isUC ? orgaoGestor : responsavel || "—"}</p></div>
                    {isUC && <div><span className="text-xs text-foreground-500">Instrumento Legal</span><p className="text-foreground-900">{instrumentoLegal || "—"}</p></div>}
                    {isUC && <div><span className="text-xs text-foreground-500">Plano de Manejo</span><p className="text-foreground-900">{temPlanoManejo ? "Sim" : "Não"}</p></div>}
                    <div><span className="text-xs text-foreground-500">Status</span><p className="text-foreground-900">{status || "—"}</p></div>
                  </div>
                </div>
                <div>
                  <label className="text-xs text-foreground-500 mb-1 block">Observações</label>
                  <textarea value={observacoes} onChange={(e) => setObservacoes(e.target.value)} placeholder="Informações adicionais..." rows={3} className="w-full px-3 py-2 text-sm border border-background-200 rounded-btn focus:outline-none focus:border-primary-400 bg-background-50 resize-none" />
                </div>
              </div>
            )}
          </div>

          {/* Footer */}
          <div className="flex items-center justify-between px-6 py-4 border-t border-background-200">
            <button onClick={onClose} className="btn-outline text-xs px-4 py-2 cursor-pointer">
              Cancelar
            </button>
            <div className="flex gap-2">
              {step > 1 && (
                <button onClick={() => setStep(step - 1)} className="btn-outline text-xs px-4 py-2 cursor-pointer">
                  <i className="ri-arrow-left-line mr-1"></i>
                  Voltar
                </button>
              )}
              {step < 3 ? (
                <button onClick={() => setStep(step + 1)} className="btn-primary text-xs px-4 py-2 cursor-pointer">
                  Próximo
                  <i className="ri-arrow-right-line ml-1"></i>
                </button>
              ) : (
                <button onClick={handleSubmit} className="btn-primary text-xs px-4 py-2 cursor-pointer">
                  <i className="ri-check-line mr-1"></i>
                  Salvar
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}